import Styled from "styled-components";
import { respondTo } from "@/respondTo";



export const GoalContainer = Styled.div`
    display: flex;
    position: relative;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width: 100%;
`


export const TextContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 2.5rem 1.25rem 0rem;

    

    ${respondTo.tablet_landscape_s`
        margin: 2.5rem 2.5rem 3.125rem;
      
    `}

    ${respondTo.desktop_xl`
        margin:2.5rem 4.375rem 3.75rem;
        padding: 0 2.5rem;
    `}
`;

export const SlideContainer = Styled.div<{ref?:any}>`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    overflow-x: scroll;
    overflow-y: hidden;
    padding:  0.625rem 1.25rem 0.625rem;
    gap: 1.25rem;
   
    
    ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}
    ${respondTo.tablet_landscape_s`
       padding: 1.25rem 2.5rem 2.5rem;
       gap: 2.5rem;
    `}

    ${respondTo.desktop_xl`
        padding-top:1.25rem ;
        padding-bottom: 2.5rem;
        padding-left: calc(50% - 720px + 3.125rem);
        padding-right:calc(50% -  720px + 3.125rem);
       
    `}

    ${respondTo.desktop_HD`
        justify-content: center;
        `}
    `